// @core/api/endpoints/workflow/delete_environment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/workflow';

/**
 * Delete environment
 * Deletes a pipeline environment and its credential bindings.
 */
export async function DeleteEnvironment(
  environment_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/environments/:environment_id`;
  requestPath = requestPath.replace(':environment_id', encodeURIComponent(environment_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
